var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container flex-wrapper"},[_c('div',{staticClass:"wrapper-centered"},[(_vm.isSuccess)?_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.thankYouPage.success')))]):_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.thankYouPage.error')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }